var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"fuller",staticClass:"full",style:({ opacity: _vm.opacity })},[_c('div',{ref:"mathJaxEl",staticClass:"display",domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }